import { mapEnumToOptions } from '@abp/ng.core';

export enum Genders {
  Female = 0,
  Male = 1,
  PreferNotToSay = 2,
}

export const gendersOptions = mapEnumToOptions(Genders);
